var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconUploadEditImg = function SvgIconUploadEditImg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m5.003 18.363.01-2.893 6.908-6.864 2.92 2.866-6.945 6.9-2.893-.009Zm10.902-7.949 1.886-1.873a.082.082 0 0 0 0-.116l-2.768-2.786a.082.082 0 0 0-.115 0l-1.923 1.91 2.92 2.865ZM8.667 19.72a.527.527 0 0 1-.373.154l-4.269-.014a.527.527 0 0 1-.525-.53l.014-4.268c0-.14.056-.273.155-.372L13.85 4.574a1.582 1.582 0 0 1 2.237.007l2.768 2.787c.616.62.613 1.62-.007 2.237L8.668 19.72Z",
    fill: "#57595E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.49 19.317h6",
    stroke: "#57595E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
export default SvgIconUploadEditImg;